import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { BottomsheetShared } from '../../general/shared/bottomsheet-shared';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { LoadingShared } from '../../general/shared/loading-shared';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { DietSearchMealModel } from 'src/app/core/model/object/diet-model';
import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';
import { TextHelper } from 'src/app/utils/text-helper';

@Component({
  selector: 'app-change-meal',
  templateUrl: './change-meal.component.html',
  styleUrls: ['./change-meal.component.scss'],
})
export class ChangeMealComponent implements OnInit, OnDestroy {
  searchText: string;
  searchedMealsFoodsName: string[] = [];
  searchedMeals: DietSearchMealModel[] = [];
  recentSearchesFoodsName: string[] = [];
  recentSearches: DietSearchMealModel[] = [];
  showDetail = false;
  dietId: string;
  day: string;
  meal: string;

  showLoading = false;

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;

  constructor(
    private planService: PlanService,
    private bottomsheetShared: BottomsheetShared,
    private route: ActivatedRoute,
    private loadingShared: LoadingShared,
    private snackBarService: SnackBarService,
    private diaryAnalytics: DiaryAnalyticsService,
    private textHelper: TextHelper
  ) {
    this.day = this.route.snapshot.paramMap.get('day');
    this.dietId = this.route.snapshot.paramMap.get('dietId');
    this.meal = this.route.snapshot.paramMap.get('meal');
    this.searchedMealsFoodsName = [];
    this.searchedMeals = [];

    let foodNames = '';
    // this.planService
    //   .getRecentSearchedPackages(this.dietId, this.meal)
    //   .then((res) => {
    //     res.forEach((recent) => {
    //       foodNames = '';
    //       recent.foods.forEach((food, index, array) => {
    //         foodNames +=
    //           array.length - 1 !== index
    //             ? food.foodId.name + '، '
    //             : food.foodId.name;
    //       });
    //       this.recentSearchesFoodsName.push(foodNames);
    //       this.recentSearches.push(recent);
    //     });
    //   });

    this.subscription1 = this.bottomsheetShared.closeBottomsheetObs$.subscribe(
      (close) => {
        if (close) {
          this.showDetail = false;
        }
      }
    );
    this.subscription2 =
      this.bottomsheetShared.closeAndUpdateBottomsheetObs$.subscribe(
        (close) => {
          if (close) {
            this.showDetail = false;
            this.back();
          }
        }
      );
    this.subscription3 = this.loadingShared.showLoadingObs$.subscribe(
      (show) => {
        if (show) {
          this.showLoading = true;
        }
      }
    );
    this.subscription4 = this.loadingShared.hideLoadingObs$.subscribe(
      (hide) => {
        if (hide) {
          this.showLoading = false;
        }
      }
    );
  }

  ngOnInit() {
    this.diaryAnalytics.analyticDiaryPackageSearchPackageVisited();
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
  }

  back() {
    this.planService.goBack();
  }

  search() {
    const text = this.searchText;
    if (this.searchText && this.searchText !== '') {
      this.showLoading = true;
      this.planService
        .findPackage(
          this.dietId,
          this.meal,
          this.textHelper.replaceArabicLettersWithPersian(this.searchText)
        )
        .then((res) => {
          if (text === this.searchText) {
            this.searchedMeals = [];
            this.searchedMealsFoodsName = [];
            if (res.isSuccess()) {
              res
                .getData()
                .getMeals()
                .forEach((meal) => {
                  // console.log(meal.foods);
                  let foodNames = '';
                  meal.foods.forEach((food, index, array) => {
                    foodNames +=
                      array.length - 1 !== index
                        ? food.foodId.name + '، '
                        : food.foodId.name;
                  });
                  this.searchedMealsFoodsName.push(foodNames);
                  this.searchedMeals.push(meal);
                });
            } else {
              this.snackBarService.showSnackBar(
                'خطا در برقراری ارتباط با سرور!'
              );
            }
          }
          this.showLoading = false;
        });
    } else {
      this.searchedMealsFoodsName = [];
      this.searchedMeals = [];
    }
  }

  clearSearchText() {
    this.searchText = '';
  }

  mealDetail(index: number) {
    this.showLoading = true;
    this.planService
      .getSelectedPackage(this.dietId, this.searchedMeals[index]._id)
      .then((res) => {
        if (res.isSuccess()) {
          const selectedPackage = res.getData().getMeals()[0];
          this.bottomsheetShared.selectedPackage = selectedPackage;
          this.bottomsheetShared.selectedDietId = this.dietId;
          this.bottomsheetShared.selectedDay = this.day;
          this.bottomsheetShared.selectedMeal = this.meal;
          this.showDetail = true;
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
        this.showLoading = false;
      });
  }

  mealDetailRecently(index: number) {
    this.bottomsheetShared.selectedPackage = this.recentSearches[index];
    this.bottomsheetShared.selectedDietId = this.dietId;
    this.bottomsheetShared.selectedDay = this.day;
    this.bottomsheetShared.selectedMeal = this.meal;
    this.showDetail = true;
  }
}
